const GoToZooInitialText ="You have decided to go to the zoo.  When you " +
    "arrive, you find out that the animals have all escaped.  The people " +
    "at the zoo are asking if you can help to round them up and get them back "+ 
    "into their habitats. When you believe you have accomplished this,  click the 'Check' " +
    "button. You can click the 'Done' button if you decide not to complete the sorting " +
    "for all of the animals." 
        
export default GoToZooInitialText 
 